import React, { useEffect, useState } from "react";
import { RoleResponse } from "../../app/models/responseModels/roleResponse";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
  Autocomplete,
  Button,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

type RoleDataFilterProps = {
  roleData: RoleResponse[];
  setFilteredData: React.Dispatch<React.SetStateAction<RoleResponse[]>>;
  filteredData: RoleResponse[];
};

const RoleDataFilter = ({
  roleData,
  setFilteredData,
  filteredData,
}: RoleDataFilterProps) => {
  // ***** States *****
  const [open, setOpen] = React.useState(false);

  const [deletedFilter, setDeletedFilter] = useState<string>("");

  const [nameOptions, setNameOptions] = useState<string[]>([]); //Dropdown Options
  const [nameSelectedOptions, setNameSelectedOptions] = useState<string[]>([]); //Dropdown selected value

  const toggle = () => {
    setOpen(!open);
  };

  // ***** UseEffects *****
  useEffect(() => {
    setNameOptions(
      roleData
        .map((v) => v.name)
        .filter((value, index, array) => array.indexOf(value) === index)
    );
  }, [filteredData, roleData]);

  useEffect(() => {
    let newData = [...roleData];
    //Name Filter
    if (nameSelectedOptions.length > 0) {
      newData = newData.filter((a) => {
        return nameSelectedOptions.some((s) => {
          return s === a.name;
        });
      });
    }

    if (deletedFilter.length > 0) {
      if (deletedFilter === "true") {
        newData = newData.filter((a) => a.deleted);
      } else {
        newData = newData.filter((a) => !a.deleted);
      }
    }

    setFilteredData(newData);
  }, [nameSelectedOptions, roleData, setFilteredData, deletedFilter]);

  // ***** Handlers *****
  const handleReset = (e: any) => {
    setDeletedFilter("");
    setNameSelectedOptions([]);
  };

  return (
    <div>
      <Accordion elevation={5} expanded={open}>
        <AccordionSummary
          onClick={toggle}
          expandIcon={
            <>
              <IconButton onClick={toggle} sx={{ color: "white" }}>
                <ExpandMore sx={{ color: "white" }} />
              </IconButton>
            </>
          }
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{
            minHeight: "36px",
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
            "& .MuiAccordionSummary-content.Mui-expanded": {
              margin: 0,
            },

            "&.Mui-expanded": {
              minHeight: "36px",
            },
            backgroundColor: "primary.main",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              color: "white",
            }}
          >
            <Typography>Search Role</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ maxHeight: 440, overflowY: "scroll" }}>
          {/* sx={{ height: 220, overflowY: "scroll" }} */}
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Grid container rowSpacing={2} columnSpacing={2}>
              <Grid item xs={12} sm={5} md={5} lg={5}>
                <Autocomplete
                  filterSelectedOptions
                  key={"roleName"}
                  size="small"
                  limitTags={3}
                  multiple
                  value={nameSelectedOptions}
                  options={nameOptions}
                  getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option: string, value: string) =>
                    option === value
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      margin="normal"
                      id="role"
                      label="Role Name"
                      name="role"
                      size="small"
                      fullWidth
                    />
                  )}
                  onChange={(event: any, selectedRoleNames: string[]) => {
                    setNameSelectedOptions(selectedRoleNames);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={5} md={5} lg={5}>
                <TextField
                  select
                  margin="normal"
                  id="deleted"
                  label="Deleted"
                  name="deleted"
                  size="small"
                  fullWidth
                  value={deletedFilter}
                  onChange={(event) => setDeletedFilter(event.target.value)}
                >
                  <MenuItem key="true" value="true">
                    True
                  </MenuItem>
                  <MenuItem key="false" value="false">
                    False
                  </MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </Box>
          <Grid container spacing={2}>
            <Grid xs={12} item>
              <>
                <Box display={"flex"} justifyContent="end">
                  <Button
                    variant="contained"
                    sx={{ mt: 2 }}
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </Box>
              </>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default RoleDataFilter;
